<template>
    <div>
    </div>
  </template>
  
  <script>
  // 根据你的实际请求api.js位置路径修改
  import {
  
  
  } from "@/api/index";
  // 根据你的实际添加编辑组件位置路径修改
  import {shortcuts} from "@/libs/shortcuts";
  import {router} from "@/router";
  import {validateMobile, validatePassword} from "@/libs/validate";
  
  export default {
    name: "companyInfo",
    components: {},
    data() {
      return {

        height: 600,
      }
    },
    methods: {
        init(){

        }
    },
    mounted() {
      this.init();
      window.onresize = () => {
      return (() => {
        this.height = (window.innerHeight)
      })()
    }
  }
  };
  </script>
  
  <style>

.vxe-pager.is--perfect .vxe-pager--num-btn:not(.is--disabled).is--active{
  background-color: #b6986d;
}

.is--checked.vxe-checkbox, .is--checked.vxe-checkbox .vxe-checkbox--icon, .is--checked.vxe-custom--option, .is--checked.vxe-custom--option .vxe-checkbox--icon, .is--checked.vxe-export--panel-column-option, .is--checked.vxe-export--panel-column-option .vxe-checkbox--icon, .is--checked.vxe-table--filter-option, .is--checked.vxe-table--filter-option .vxe-checkbox--icon, .is--indeterminate.vxe-checkbox, .is--indeterminate.vxe-checkbox .vxe-checkbox--icon, .is--indeterminate.vxe-custom--option, .is--indeterminate.vxe-custom--option .vxe-checkbox--icon, .is--indeterminate.vxe-export--panel-column-option, .is--indeterminate.vxe-export--panel-column-option .vxe-checkbox--icon, .is--indeterminate.vxe-table--filter-option, .is--indeterminate.vxe-table--filter-option .vxe-checkbox--icon, .vxe-table--render-default .is--checked.vxe-cell--checkbox, .vxe-table--render-default .is--checked.vxe-cell--checkbox .vxe-checkbox--icon, .vxe-table--render-default .is--indeterminate.vxe-cell--checkbox, .vxe-table--render-default .is--indeterminate.vxe-cell--checkbox .vxe-checkbox--icon{
  color:#b6986d
}
  
  </style>
  